import { React, useState } from 'react';
import SideBar from '../SideBar/SideBar';
import CollapseIcon from '../../assets/images/sidebar_collapse_arrow.svg';
// import { Spinner } from 'react-bootstrap';
import './Loader.scss';

import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

function Loader({ show, history }) {
    const [isActive, setActive] = useState("false");

    const handleToggle = () => {
        setActive(!isActive);
    };

    return (
        <div className='sidebar_main_wrapper'>
            <div className={isActive ? "sidebar" : "sidebar sidebar-collapse"}>
                <button onClick={handleToggle} className={isActive ? 'collapse-icon' : 'collapse-icon rotate-icon'}>
                    <img src={CollapseIcon} alt="icon" />
                </button>
                <SideBar />
            </div>
            <div className={isActive ? "right-container" : "right-container right-container-collapse"}>
                <div className='right-inner-container'>
                    {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '500px' }}>
                        <Spinner
                            as="span"
                            animation="border"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant='primary'
                            style={{
                                width: "100px",
                                height: "100px",
                                margin: "auto",
                                display: "block"
                            }}
                        />
                    </div> */}

                    <div className="spinner" >
                        <Loaders
                            type="ThreeDots"
                            color="#192f60"
                            height={70}
                            width={70}
                            timeout={3000}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Loader;
